var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.hidePane)?_c('div',{staticClass:"bd-bottom-gray p-3"},[_c('div',{staticClass:"d-flex justify-content-between pane-title",staticStyle:{"min-height":"30px"}},[_c('span',{class:{ 'font-weight-bold': _vm.boldTitle }},[_vm._t("close"),_vm._t("title"),_vm._t("titleIcon")],2),_vm._t("actions")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }